/* tslint:disable */
/* eslint-disable */
/**
 * Strømbestilling API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const OrderOfferStatus = {
    Created: 'CREATED',
    Opened: 'OPENED',
    Ordered: 'ORDERED',
    CreditCheckBlocked: 'CREDIT_CHECK_BLOCKED',
    CreditCheckFailed: 'CREDIT_CHECK_FAILED',
    Expired: 'EXPIRED',
    PendingConsent: 'PENDING_CONSENT',
    ConsentExpired: 'CONSENT_EXPIRED',
    ConsentRejected: 'CONSENT_REJECTED',
    ConsentError: 'CONSENT_ERROR'
} as const;
export type OrderOfferStatus = typeof OrderOfferStatus[keyof typeof OrderOfferStatus];


export function instanceOfOrderOfferStatus(value: any): boolean {
    for (const key in OrderOfferStatus) {
        if (Object.prototype.hasOwnProperty.call(OrderOfferStatus, key)) {
            if (OrderOfferStatus[key as keyof typeof OrderOfferStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OrderOfferStatusFromJSON(json: any): OrderOfferStatus {
    return OrderOfferStatusFromJSONTyped(json, false);
}

export function OrderOfferStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderOfferStatus {
    return json as OrderOfferStatus;
}

export function OrderOfferStatusToJSON(value?: OrderOfferStatus | null): any {
    return value as any;
}

export function OrderOfferStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): OrderOfferStatus {
    return value as OrderOfferStatus;
}

